export const lightTheme = {
  color: '#121212'
};

export const darkTheme = {
  color: '#fff'
};

// Node styling constants

export const nodeStyles = {
  // Base styling shared by all nodes
  base: {
    padding: '5px',
    borderRadius: '8px',
    backgroundColor: '#1e1e1e',
    boxShadow: `0px 6px 8px 1px rgba(255, 255, 255, 0.05),
  0px 6px 8px 1px rgba(255, 255, 255, 0.13),
  0px 1px 2px 1px rgba(255, 255, 255, 0.2)`,
    minWidth: '160px',
    minHeight: '70px',
    textAlign: 'center',
    fontSize: '16px',
    position: 'relative',
    cursor: 'move',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  startNodeBorder: (selected) => (selected ? { border: '3px solid #fff' } : { border: '3px solid #4ade80' }),
  endNodeBorder: (selected) => (selected ? { border: '3px solid #fff' } : { border: '3px solid #fb923c' }),
  agentNodeBorder: (selected) => (selected ? { border: '3px solid #fff' } : { border: '3px solid #a78bfa' }),
  toolNodeBorder: (selected) => (selected ? { border: '3px solid #fff' } : { border: '3px solid #fcd34d' }),
  supervisorNodeBorder: (selected) => (selected ? { border: '3px solid #fff' } : { border: '3px solid #eb6134' }),

  // Agent node specific styling
  agent: {
    color: '#a78bfa'
  },

  nodesTextStyle: {
    fontSize: '24px',
    textAlign: 'center',
    padding: '25px'
  },

  // Supervisor node specific styling
  supervisor: {
    color: '#eb6134'
    // border: '2px solid #eb6134'
  },

  // Start node specific styling
  start: {
    color: '#4ade80'
    // border: '2px solid #4ade80'
  },

  // End node specific styling
  end: {
    color: '#fb923c'
    // border: '2px solid #fb923c'
  },

  // Tool node specific styling
  tool: {
    color: '#fcd34d'
    // border: '2px solid #fcd34d'
  },

  iconPosition: {
    margin: '0 auto'
  }
};

// Handle styling
export const handleStyles = {
  // Base handle styling shared by all handles
  base: {
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    opacity: 0.85,
    '&:hover': {
      opacity: 1,
      transform: 'scale(1.2)'
    }
  },

  // Agent specific handle styling
  agent: {
    background: '#a78bfa'
  },

  supervisor: {
    background: '#eb6134'
  },

  // Start specific handle styling
  start: {
    background: '#4ade80'
  },

  // End specific handle styling
  end: {
    background: '#fb923c'
  },

  // Tool specific handle styling
  tool: {
    background: '#fcd34d'
  },

  // Position-specific styling
  top: {
    top: '-12px'
  },
  bottom: {
    bottom: '-12px'
  },
  left: {
    left: '-12px'
  },
  right: {
    right: '-12px'
  }
};

// Edge styling
export const edgeStyles = {
  // Base edge styling
  base: {
    strokeWidth: 2
  },

  // Edge colors
  colors: {
    agent: '#a78bfa',
    supervisor: '#eb6134',
    tool: '#fcd34d',
    start: '#4ade80',
    end: '#fb923c'
  },

  // Edge types
  dashed: {
    strokeDasharray: '7,4',
    strokeWidth: 2.5
  }
};

// Button styling
export const buttonStyles = {
  base: {
    width: '100%',
    marginBottom: '5px',
    background: '#4a4a4a',
    color: 'white',
    border: '1px solid #666',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '4px'
  },
  hover: {
    background: '#5a5a5a'
  },
  disabled: {
    background: '#3a3a3a',
    color: '#999',
    cursor: 'not-allowed'
  }
};

// Sidebar styling
export const sidebarStyles = {
  container: {
    width: '200px',
    background: '#2d2d2d',
    padding: '10px',
    boxSizing: 'border-box'
  },
  optionsContainer: {
    marginTop: '20px',
    padding: '10px',
    background: '#333',
    borderRadius: '4px',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  tip: {
    marginTop: '10px',
    fontSize: '0.9em',
    color: '#999',
    textAlign: 'center'
  }
};

// Context menu styling
export const contextMenuStyles = {
  container: {
    position: 'absolute',
    padding: '8px',
    borderRadius: '4px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  button: {
    border: '1px solid #fff',
    padding: '4px 8px',
    cursor: 'pointer',
    borderRadius: '4px',
    minWidth: '120px'
  },
  buttonDisabled: {
    border: '1px solid #fff',
    padding: '4px 8px',
    cursor: 'not-allowed',
    borderRadius: '4px',
    minWidth: '120px'
  }
};

export const nodeGroupButton = {
  detachButton: {
    fontWeight: 700,
    position: 'absolute',
    top: '-20px',
    background: '#eee',
    color: '#111',
    borderRadius: '3px',
    border: '1px solid #cdcdcd',
    width: 'auto',
    height: 20,
    fontSize: 10,
    cursor: 'pointer',
    lineHeight: '18px'
  },
  ungroupButton: {
    fontWeight: 700,
    position: 'absolute',
    top: '-25px',
    background: '#eee',
    color: '#111',
    borderRadius: '3px',
    border: '1px solid #cdcdcd',
    width: 'auto',
    height: 20,
    fontSize: 10,
    cursor: 'pointer',
    lineHeight: '18px'
  }
};
